import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Empty, Descriptions, Avatar, Table, Button, Input, Radio } from 'antd';
import * as actions from './redux/actions';
import { PageDetail, Page, Crud, Upload } from '../../components';
import { config } from '../../utils/config';
const { SelectFile } = Upload;
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud
const yesorno = [
  {
    value: 1,
    label: "是"
  },
  {
    value: 0,
    label: "否"
  },
]
export class CompanyMessage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { user, actions } = this.props
    const { getCompanyActions } = actions
    let { igasvID } = JSON.parse(sessionStorage.getItem('user'))
    getCompanyActions(igasvID).then((res) => {
      console.log(res)
    })
  }
  //  点击编辑显示
  compile = () => {
    const { companyShowForm, changeCompany } = this.props.actions
    const { Companymessage } = this.props.user
    companyShowForm(true)
    changeCompany(Companymessage)
  }


  uploadFile2 = (igasvID, seljyEsignoss) => {
    const { actions } = this.props
    const { uploadingSealActions } = actions
    // 3. 提交电子章图
    let paramss2 = new FormData()
    paramss2.append('file', seljyEsignoss)
    uploadingSealActions(paramss2, igasvID).then((res) => {
    })

  }

  get modalProps() {
    const { user, actions } = this.props
    const { userModalVisible, changeCompanyActionsPending, userCompany, } = user
    const { companyShowForm, changeCompanyActions, getCompanyActions, uploadingYyzzActions, uploadingSealActions } = actions
    let editItem = userCompany !== undefined && userCompany !== null ? userCompany : {}
    console.log(editItem)
    //  上传营业执照
    let imgYyzz = []
    if (editItem.imageossYyzz) {
      imgYyzz.push({ name: editItem.imageossYyzz, url: editItem.imageossYyzzUrl })
    }
    // 上传电子图章照片
    let imgSeal = []
    if (editItem.jyEsignoss) {
      imgSeal.push({ name: editItem.jyEsignoss, url: editItem.jyEsignossUrl })
    }
    return {
      visible: userModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: changeCompanyActionsPending,
      title: '编辑',
      centered: true,
      elements: [
        {
          key: "borough",
          label: "乡镇街道",
          initialValue: editItem.borough,
          widget: Input,

        },
        {
          key: "city",
          label: "所在市",
          initialValue: editItem.city,
          widget: Input,

        },
        {
          key: "contact",
          label: "业务联系人",
          initialValue: editItem.contact,
          widget: Input,

        },
        {
          key: "contactMob",
          label: "联系电话",
          initialValue: editItem.contactMob,
          widget: Input,

        },
        {
          key: "county",
          label: "所在区县",
          initialValue: editItem.county,
          widget: Input,

        },
        {
          key: "email",
          label: "电子邮箱",
          initialValue: editItem.email,
          widget: Input,

        },
        {
          key: "fax",
          label: "传真",
          initialValue: editItem.fax,
          widget: Input,

        },
        {
          key: "igasvID",
          label: "授权编号",
          initialValue: editItem.igasvID,
          widget: Input,


          // disabled: true
        },
        {
          key: "jingdu",
          label: "经度",
          initialValue: editItem.jingdu,
          widget: Input,

        },
        {
          key: "weidu",
          label: "纬度",
          initialValue: editItem.weidu,
          widget: Input,

        },
        {
          key: "province",
          label: "省份",
          initialValue: editItem.province,
          widget: Input,

        },
        {
          key: "tel",
          label: "电话号码",
          initialValue: editItem.tel,
          widget: Input,

        },
        {
          key: "unitaddress",
          label: "单位地址",
          initialValue: editItem.unitaddress,
          widget: Input,

        },
        {
          key: "unitname",
          label: "单位名称",
          initialValue: editItem.unitname,
          // initialValue: "张家港富瑞深冷科技有限公司",
          widget: Input,
        },
        {
          key: "unitnameJc",
          label: "单位简称",
          initialValue: editItem.unitnameJc,
          widget: Input,

        },
        {
          key: "usccode",
          label: "社会信用代码",
          initialValue: editItem.usccode,
          // initialValue: "91320592MA1MM6GH6E",
          widget: Input,


          // disabled: true,
        },
        {
          key: "web",
          label: "网址",
          initialValue: editItem.web,
          widget: Input,

        },
        {
          key: "zipcode",
          label: "邮政编码",
          initialValue: editItem.zipcode,
          widget: Input,

        },
        {
          key: "zzESign",
          label: "使用电子图章",
          initialValue: editItem.zzESign,
          widget: Radio.Group,
          maxCount: 1,
          widgetProps: {
            options: yesorno,
          },

        },
        {
          key: "selimageossYyzz",
          label: "营业执照",
          initialValue: editItem === undefined ? [] : imgYyzz,
          widget: SelectFile,
          maxCount: 1,
          widgetProps: {
          },
        },

        {
          key: "seljyEsignoss",
          label: "电子图章图片",
          initialValue: editItem === undefined ? [] : imgSeal,
          widget: SelectFile,
          maxCount: 1,
          widgetProps: {
          },
        },
      ],
      onOk: datas => {
        console.log('sa', datas);
        // 1. 修改公司信息
        changeCompanyActions(Object.assign({}, datas, { id: datas.igasvID })).then(data => {
          companyShowForm(false, "create");
          let { igasvID } = JSON.parse(sessionStorage.getItem('user'))
          getCompanyActions(igasvID).then((res) => {
          })
        });
        let self = this;
        console.log('sa-selimageossYyzz', datas.selimageossYyzz instanceof Array);
        if (datas.selimageossYyzz instanceof Array) {

          if (datas.seljyEsignoss instanceof Array) {

          } else {
            self.uploadFile2(datas.igasvID, datas.seljyEsignoss);
          }


        } else {
          // 2. 提交营业执照
          let params1 = new FormData()
          params1.append('file', datas.selimageossYyzz)
          uploadingYyzzActions(params1, datas.igasvID).then((res) => {

            if (datas.seljyEsignoss instanceof Array) {

            } else {
              self.uploadFile2(datas.igasvID, datas.seljyEsignoss);
            }


          })
        }



      },
      onCancel() {
        companyShowForm(false, "create");
      },
    }
  }
  render() {
    const { Companymessage } = this.props.user
    let { userCompany } = this.props.user
    console.log(userCompany, Companymessage)
    if (Companymessage === undefined) {
      return <Empty />
    }
    return (
      <Page inner>

        <Descriptions bordered>
          <Descriptions.Item label="邮政编号">{Companymessage.zipcode !== undefined && Companymessage.zipcode !== null ? Companymessage.zipcode : ''}</Descriptions.Item>
          <Descriptions.Item label="单位名称">{Companymessage.unitnameJc !== undefined && Companymessage.unitnameJc !== null ? Companymessage.unitnameJc : ''}</Descriptions.Item>
          <Descriptions.Item label="所在乡镇">{Companymessage.borough !== undefined && Companymessage.borough !== null ? Companymessage.borough : ''}</Descriptions.Item>
          <Descriptions.Item label="所在市">{Companymessage.city !== undefined && Companymessage.city !== null ? Companymessage.city : ''}</Descriptions.Item>
          <Descriptions.Item label="省份">{Companymessage.province !== undefined && Companymessage.province !== null ? Companymessage.province : ''}</Descriptions.Item>
          <Descriptions.Item label="传真">{Companymessage.fax !== undefined && Companymessage.fax !== null ? Companymessage.fax : ''}</Descriptions.Item>
          <Descriptions.Item label="业务联系人">{Companymessage.contact !== undefined && Companymessage.contact !== null ? Companymessage.contact : ''}</Descriptions.Item>
          <Descriptions.Item label="联系电话">{Companymessage.tel !== undefined && Companymessage.tel !== null ? Companymessage.tel : ''}</Descriptions.Item>
          <Descriptions.Item label="授权编号">{Companymessage.igasvID !== undefined && Companymessage.igasvID !== null ? Companymessage.igasvID : ''}</Descriptions.Item>
          <Descriptions.Item label="传真">{Companymessage.fax !== undefined && Companymessage.fax !== null ? Companymessage.fax : ''}</Descriptions.Item>
          <Descriptions.Item label="所在区县">
            {Companymessage.county !== undefined && Companymessage.county !== null ? Companymessage.county : ''}
          </Descriptions.Item>
          <Descriptions.Item label="邮箱" >
            {Companymessage.email !== undefined && Companymessage.email !== null ? Companymessage.email : ''}
          </Descriptions.Item>
          <Descriptions.Item label="单位地址" span={3}>
            {Companymessage.unitaddress !== undefined && Companymessage.unitaddress !== null ? Companymessage.unitaddress : ''}
          </Descriptions.Item>
          <Descriptions.Item label="网址" span={3}>
            {Companymessage.web !== undefined && Companymessage.web !== null ? Companymessage.web : ''}
          </Descriptions.Item>
          <Descriptions.Item label="经度" span={2}>
            {Companymessage.jingdu !== undefined && Companymessage.jingdu !== null ? Companymessage.jingdu : ''}
          </Descriptions.Item>
          <Descriptions.Item label="纬度" span={2}>
            {Companymessage.weidu !== undefined && Companymessage.weidu !== null ? Companymessage.weidu : ''}
          </Descriptions.Item>
          <Descriptions.Item label="公司营业执照">
            <img width={200}
              height={200} src={Companymessage.imageossYyzz !== undefined && Companymessage.imageossYyzz !== null ?  `${config.attachUrl}${Companymessage.imageossYyzz}` : ''} />
          </Descriptions.Item>
          <Descriptions.Item label="电子图章图片">
            <img width={200}
              height={200} src={Companymessage.jyEsignoss !== undefined && Companymessage.jyEsignoss !== null ?  `${config.attachUrl}${Companymessage.jyEsignoss}` : ''} />
          </Descriptions.Item>
        </Descriptions>
        <Button onClick={this.compile} className='button' type="primary">编辑</Button>
        <div>
          <CrudForm {...this.modalProps} />
        </div>
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyMessage);



// WEBPACK FOOTER //
// ./src/features/user/CompanyMessage.js